import React from "react";
import { FormattedMessage, injectIntl, Link } from "gatsby-plugin-intl";
import { Icon, Grid, Segment, Header, Button } from "semantic-ui-react";
import { PICPICK_LATEST_KO_VERSION, PICPICK_BETA_VERSION } from "../constants";

const TableFreeOnly = ({ intl }) => (
  <Grid columns="2" divided padded centered stackable verticalAlign="middle">
    <Grid.Column>
      <Segment.Group>
        <Segment secondary textAlign="center">
          <Header color="grey" as="h4" icon style={{ marginBottom: 0 }}>
            <Icon name="group" />
            <FormattedMessage id="download_1_h1" />
          </Header>
        </Segment>
        <Segment padded textAlign="center">
          <Header style={{ height: 70, paddingTop: 25 }} color="green">
            <p>
              <FormattedMessage id="text_free" />
            </p>
          </Header>
        </Segment>
        <Segment>
          <FormattedMessage id="download_1_p1" />
          <Icon name="check circle" color="green" style={{ float: "right" }} />
        </Segment>
        <Segment>
          <FormattedMessage id="download_1_p2" />
          <Icon name="check circle" color="green" style={{ float: "right" }} />
        </Segment>
        <Segment>
          <FormattedMessage id="download_1_p3" />
          <Icon
            name="exclamation circle"
            color="red"
            style={{ float: "right" }}
          />
        </Segment>
        <Segment>
          <FormattedMessage id="download_1_p4" />
          <Icon
            name="exclamation circle"
            color="red"
            style={{ float: "right" }}
          />
        </Segment>
        <Segment>&nbsp;</Segment>
        <Segment>
          <Button
            size="huge"
            color="orange"
            fluid
            content={`${intl.formatMessage({
              id: "nav_download",
            })} v${PICPICK_BETA_VERSION} (x64)`}
            as={Link}
            name="download_start"
            to="/beta"
          />
        </Segment>
        <Segment>
          <Button
            size="huge"
            color="blue"
            fluid
            content={`${intl.formatMessage({
              id: "nav_download",
            })} v${PICPICK_LATEST_KO_VERSION}`}
            as={Link}
            name="download_start"
            to="/download/kr"
          />
        </Segment>
      </Segment.Group>
    </Grid.Column>
  </Grid>
);

export default injectIntl(TableFreeOnly);
